import React from "react";
import { Button, OverlayTrigger } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";

export const TransactionHistoryFilter = ({
  tFilterDate,
  setTFilterDate,
  t,
}) => {
  return (
    <div className="row m-0 invoices-row">
      <div className="col-md-3 pl-0 col-sm-6 mb-2">
        <OverlayTrigger placement="top">
          <DatePicker
            render={<InputIcon placeholder={t("From")} />}
            value={tFilterDate?.from}
            onChange={(date) => {
              setTFilterDate((prevState) => ({
                ...prevState,
                from: new Date(date),
              }));
            }}
          />
        </OverlayTrigger>
      </div>
      <div className="col-md-3 pl-0 col-sm-6 mb-2">
        <OverlayTrigger placement="top">
          <DatePicker
            render={<InputIcon placeholder={t("To")} />}
            value={tFilterDate?.to}
            className="ml-2"
            onChange={(date) => {
              setTFilterDate((prevState) => ({
                ...prevState,
                to: new Date(date),
              }));
            }}
          />
        </OverlayTrigger>
      </div>
      <div className="col-md-3 pl-0 col-sm-6 mb-2">
        <Button
          variant="outline-primary"
          className="mb-2"
          onClick={() => setTFilterDate({ from: "", to: "" })}
        >
          {t("Clear")}
        </Button>
      </div>
    </div>
  );
};
